import React, { useEffect, useRef } from 'react';
import { SiteContentProvider } from './SiteContent';
import Navbar from './Navbar';
import Hero from './Hero';
import Manifest from './Manifest';
import About from './About';
import Services from './Services';
import HowItWorks from './HowItWorks';
import Reviews from './Reviews';
import Pricing from './Pricing';
import Contact from './Contact';
import Footer from './Footer';
import AnyaWidget from './AnyaWidget';
import VacationBanner from './VacationBanner';

function useScrollReveal() {
  const rootRef = useRef(null);
  useEffect(() => {
    const els = (rootRef.current || document).querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return rootRef;
}

export default function LandingPage() {
  const rootRef = useScrollReveal();
  return (
    <SiteContentProvider>
      <div ref={rootRef} className="min-h-screen bg-cream text-ink font-body" data-testid="landing-root">
        <Navbar />
        <VacationBanner />
        <main>
          <Hero />
          <Manifest />
          <About />
          <Services />
          <HowItWorks />
          <Reviews />
          <Pricing />
          <Contact />
        </main>
        <Footer />
        <AnyaWidget />
      </div>
    </SiteContentProvider>
  );
}
